"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var genericInputStyles = makeStyles_1.default(function (_a) {
    var _b, _c;
    var typography = _a.typography, transitions = _a.transitions, palette = _a.palette, spacing = _a.spacing, breakpoints = _a.breakpoints;
    return ({
        root: {
            background: palette.common.white,
        },
        fieldWrapper: {
            position: 'relative',
            width: '100%',
        },
        input: {
            width: '100%',
            transition: transitions.create(['border-color', 'box-shadow']),
        },
        errorText: {
            fontSize: typography.fontXS,
        },
        notchedOutline: {
            borderRadius: 3,
            borderColor: palette.text.secondary,
            borderWidth: 1,
        },
        focused: {
            borderColor: palette.primary.main,
            boxShadow: 'inset 0 0 10px 1px rgba(150,184,212,0.5)',
        },
        inputError: {
            borderColor: palette.error.main,
        },
        dateCalendar: (_b = {
                '& span': {
                    color: palette.common.white,
                }
            },
            _b[breakpoints.down('sm')] = {
                paddingRight: 0,
            },
            _b),
        helperTextError: {
            margin: spacing(1),
            color: palette.error.main,
            position: 'absolute',
            top: 40,
        },
        label: {
            fontFamily: typography.fontFamily2,
            color: palette.text.primary,
            marginBottom: 6,
            lineHeight: '20px',
        },
        phonePrefix: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '52px',
            width: '48px',
            backgroundColor: palette.action.disabledBackground,
            fontSize: typography.fontMD,
            marginLeft: '-11px',
        },
        noOptions: (_c = {},
            _c[breakpoints.down('md')] = {
                fontSize: typography.fontSM,
            },
            _c[breakpoints.down('sm')] = {
                fontSize: typography.fontXS,
            },
            _c),
    });
}, { name: 'Checkout_GenericInput' });
exports.default = genericInputStyles;
